import { render, staticRenderFns } from "./TableButtonsEditSplitLine.vue?vue&type=template&id=770da770&"
import script from "./TableButtonsEditSplitLine.vue?vue&type=script&lang=js&"
export * from "./TableButtonsEditSplitLine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports